import type { MouseEvent } from "react";

// Bottom-nav tap feedback: a one-shot ripple burst from the icon's center
// plus a quick elastic wiggle on the glyph itself, instead of a persistent
// active-state pill. Both are Web Animations so they clean up on their own
// (ripple removes its own DOM node on finish) without fighting the CSS
// transitions already on .nav-icon-wrap/svg.
export function navTapFx(e: MouseEvent<HTMLButtonElement>) {
  const nav = e.currentTarget.closest<HTMLElement>(".bottomnav");
  const iconWrap = e.currentTarget.querySelector<HTMLElement>(".nav-icon-wrap");
  if (!nav || !iconWrap) return;

  const navRect = nav.getBoundingClientRect();
  const iconRect = iconWrap.getBoundingClientRect();
  const ripple = document.createElement("div");
  ripple.className = "nav-ripple";
  ripple.style.left = `${iconRect.left - navRect.left + iconRect.width / 2}px`;
  ripple.style.top = `${iconRect.top - navRect.top + iconRect.height / 2}px`;
  nav.appendChild(ripple);
  const anim = ripple.animate(
    [
      { transform: "scale(1)", opacity: 1 },
      { transform: "scale(7)", opacity: 0 },
    ],
    { duration: 500, easing: "ease-out" }
  );
  anim.onfinish = () => ripple.remove();

  iconWrap.querySelector("svg")?.animate(
    [
      { transform: "scale(1) rotate(0deg)" },
      { transform: "scale(1.3) rotate(-8deg)" },
      { transform: "scale(1) rotate(0deg)" },
    ],
    { duration: 400, easing: "cubic-bezier(.34,1.56,.64,1)" }
  );
}
